import React, { Component } from "react";
import PropTypes from "prop-types";
import apiProxy from "../../api/apiProxy.js";

const AlertWorkOrderFormWrapper = WrappedComponent => {
  return class extends Component {
    createAlertWorkOrder = (workOrderNumber, description) => {
      return apiProxy.alertWorkOrder
        .createAlertWorkOrder(this.props.alertId, workOrderNumber, description)
        .then(() => {
          this.props.onAlertWorkOrderSaved();
        });
    };

    render() {
      return (
        <WrappedComponent
          createAlertWorkOrder={this.createAlertWorkOrder}
          {...this.props}
        />
      );
    }
  };
};

AlertWorkOrderFormWrapper.propTypes = {
  alertId: PropTypes.string.isRequired
};

export default AlertWorkOrderFormWrapper;
